// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_oWp","cls2":"ImpactHubModal-cls2_Pnf ImpactHubModal-cls1_oWp"};